/** Family relationship labels for profile switcher and forms. */

const mkRelationshipTypes = (
  spouse,
  parent,
  child,
  sibling,
  friend,
  other
) => ({
  SPOUSE: spouse,
  PARENT: parent,
  CHILD: child,
  SIBLING: sibling,
  FRIEND: friend,
  OTHER: other,
});

export const RELATIONSHIP_TYPE_LOCALES = {
  en: mkRelationshipTypes("Spouse", "Parent", "Child", "Sibling", "Friend", "Other"),
  hi: mkRelationshipTypes(
    "जीवनसाथी",
    "माता-पिता",
    "बच्चा",
    "भाई-बहन",
    "मित्र",
    "अन्य"
  ),
  pa: mkRelationshipTypes(
    "ਜੀਵਨ ਸਾਥੀ",
    "ਮਾਤਾ-ਪਿਤਾ",
    "ਬੱਚਾ",
    "ਭਰਾ-ਭੈਣ",
    "ਦੋਸਤ",
    "ਹੋਰ"
  ),
  te: mkRelationshipTypes(
    "జీవిత భాగస్వామి",
    "తల్లిదండ్రులు",
    "పిల్లలు",
    "సోదరి/సోదరుడు",
    "స్నేహితుడు",
    "ఇతర"
  ),
  ta: mkRelationshipTypes(
    "வாழ்க்கைத் துணை",
    "பெற்றோர்",
    "குழந்தை",
    "உடன்பிறப்பு",
    "நண்பர்",
    "மற்றவை"
  ),
  mr: mkRelationshipTypes(
    "जोडीदार",
    "पालक",
    "मूल",
    "भावंड",
    "मित्र",
    "इतर"
  ),
  bn: mkRelationshipTypes(
    "জীবনসঙ্গী",
    "অভিভাবক",
    "সন্তান",
    "ভাইবোন",
    "বন্ধু",
    "অন্যান্য"
  ),
  kn: mkRelationshipTypes(
    "ಜೀವನ ಸಂಗಾತಿ",
    "ಪೋಷಕರು",
    "ಮಗು",
    "ಸಹೋದರ/ಸಹೋದರಿ",
    "ಸ್ನೇಹಿತ",
    "ಇತರೆ"
  ),
};

export const SELECTED_MEMBER_LABELS = {
  en: "Selected member",
  hi: "चयनित सदस्य",
  pa: "ਚੁਣਿਆ ਮੈਂਬਰ",
  te: "ఎంపిక చేసిన సభ్యుడు",
  ta: "தேர்ந்தெடுக்கப்பட்ட உறுப்பினர்",
  mr: "निवडलेला सदस्य",
  bn: "নির্বাচিত সদস্য",
  kn: "ಆಯ್ಕೆ ಮಾಡಿದ ಸದಸ್ಯ",
};

export const applyRelationshipTypeLocales = (translations) => {
  const enTypes = RELATIONSHIP_TYPE_LOCALES.en;

  Object.entries(RELATIONSHIP_TYPE_LOCALES).forEach(([lang, relationshipTypes]) => {
    if (!translations[lang]?.common) return;
    translations[lang].common = {
      ...translations[lang].common,
      relationshipTypes: {
        ...enTypes,
        ...relationshipTypes,
      },
      selectedMember:
        SELECTED_MEMBER_LABELS[lang] ||
        translations[lang].common.selectedMember ||
        SELECTED_MEMBER_LABELS.en,
    };
  });
};
